import auth from "../../middleware/auth";

export default [
  {
    path: "/online-co2/index",
    name: "Online-co2",
    component: () => import("./../../views/reports/onlineCo2/index.vue"),
    meta: {
      middleware: [auth],
      breadcrumb: [
        {
          title: "Home",
          active: false,
          url: "/"
        },
        {
          i18n: 'navmenu.analytics.online_station',
          title: "Онлайн станция",
          active: true
        }
      ]
    },
    pageTitle: "Онлайн станция",
    rule: "editor"
  },
];
